import { useSyncExternalStore } from "react";
import {
  getStickySettings,
  setStickySettings,
  STICKY_BG_PRESETS,
  stickySettingsEventName,
} from "../../editor/stickySession";
import { stickyCustomColors } from "../../editor/customColorSwatches";
import { stickyColorSlots } from "../../editor/colorSlots";
import { BoardColorSlots } from "./BoardColorSlots";

function subscribeStickySettings(onStoreChange: () => void) {
  const handler = () => onStoreChange();
  window.addEventListener(stickySettingsEventName(), handler);
  return () => window.removeEventListener(stickySettingsEventName(), handler);
}

export function BoardStickyOptions() {
  const sticky = useSyncExternalStore(
    subscribeStickySettings,
    getStickySettings,
    getStickySettings
  );
  const customColors = useSyncExternalStore(
    stickyCustomColors.subscribe,
    stickyCustomColors.get,
    stickyCustomColors.get
  );
  const slots = useSyncExternalStore(
    stickyColorSlots.subscribe,
    stickyColorSlots.get,
    stickyColorSlots.get
  );
  const activeSlot = useSyncExternalStore(
    stickyColorSlots.subscribe,
    stickyColorSlots.getActive,
    stickyColorSlots.getActive
  );

  return (
    <div className="wb-pen-options" role="group" aria-label="Цвет стикера">
      <BoardColorSlots
        slots={slots}
        activeColor={sticky.backgroundColor}
        activeIndex={activeSlot}
        presets={STICKY_BG_PRESETS}
        customColors={customColors}
        label="Цвет стикера"
        onPick={(slot, index) => {
          stickyColorSlots.setActive(index);
          setStickySettings({ backgroundColor: slot.color });
        }}
        onSetSlot={(index, patch) => stickyColorSlots.set(index, patch)}
        onAddCustom={(hex) => stickyCustomColors.add(hex, STICKY_BG_PRESETS)}
        onRemoveCustom={(hex) => stickyCustomColors.remove(hex)}
      />
    </div>
  );
}
